import clsx from "clsx";

/**
 * セクション間の 1px 罫線。 上下のコンテンツ (各 section の px-16) と左右を揃えるため、
 * 全 viewport で mx-16 を当てる (DXPJ-62 mEJaxs8: divider が content より外に出ないよう
 * content と同じインセットにする)。 PC は pane の lg:px-16 に重なり結果 32px inset = content と一致。
 */
type DxDividerProps = {
  tone?: "default" | "subtle" | "weak";
  className?: string;
};

const TONE_BORDER: Record<NonNullable<DxDividerProps["tone"]>, string> = {
  default: "border-dx-border-default",
  subtle: "border-dx-border-subtle",
  weak: "border-dx-border-weak",
};

export function DxDivider({ tone = "default", className }: DxDividerProps) {
  return <hr className={clsx(TONE_BORDER[tone], "mx-[16px]", className)} />;
}
